var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.3333H9.16667V11.6667H7.5V13.3333ZM8.33333 0C3.73333 0 0 3.73333 0 8.33333C0 12.9333 3.73333 16.6667 8.33333 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.33333 0ZM8.33333 15C4.65833 15 1.66667 12.0083 1.66667 8.33333C1.66667 4.65833 4.65833 1.66667 8.33333 1.66667C12.0083 1.66667 15 4.65833 15 8.33333C15 12.0083 12.0083 15 8.33333 15ZM8.33333 3.33333C6.49167 3.33333 5 4.825 5 6.66667H6.66667C6.66667 5.75 7.41667 5 8.33333 5C9.25 5 10 5.75 10 6.66667C10 8.33333 7.5 8.125 7.5 10.8333H9.16667C9.16667 8.95833 11.6667 8.75 11.6667 6.66667C11.6667 4.825 10.175 3.33333 8.33333 3.33333Z",
    fill: "#004895"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpOutline);
export default __webpack_public_path__ + "static/media/help_outline.f281c9ee74f836060a5924337c7d00be.svg";
export { ForwardRef as ReactComponent };